import React from 'react';
import { Stack } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IEvent } from '../../types/global/helper';
import { Checkroom, LocalActivity, PersonOutline } from '@mui/icons-material';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { TextWithIcon } from '../TextWithIcon/TextWithIcon';

export interface IEventDescripiton {
    event: IEvent;
}

const EventHighlight: React.FC<IEventDescripiton> = ({ event }) => {
    const { themeStyle } = useThemeContext();
    return (
        <React.Fragment>
            <Stack width={'100%'} justifyContent="center" my={4}>
                <Stack direction="row" gap={2} width={'100%'} justifyContent="center">
                    {event.age_restriction && (
                        <TextWithIcon
                            icon={
                                <PersonOutline
                                    sx={{
                                        color: theme[themeStyle].tag_white,
                                        fontSize: '16px',
                                    }}
                                />
                            }
                            text={`${event.age_restriction}+`}
                            typographyProps={{
                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                fontSize: {
                                    xs: 10,
                                    sm: 12,
                                    lg: 16,
                                },
                            }}
                        />
                    )}
                    {event.dress_code && (
                        <TextWithIcon
                            icon={
                                <Checkroom
                                    sx={{
                                        color: theme[themeStyle].tag_white,
                                        fontSize: '16px',
                                    }}
                                />
                            }
                            text={`${event.dress_code}`}
                            typographyProps={{
                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                fontSize: {
                                    xs: 10,
                                    sm: 12,
                                    lg: 16,
                                },
                            }}
                        />
                    )}
                    {event.max_ticket_purchasable_per_person && (
                        <TextWithIcon
                            icon={
                                <LocalActivity
                                    sx={{
                                        color: theme[themeStyle].tag_white,
                                        fontSize: '16px',
                                    }}
                                />
                            }
                            text={`${event.max_ticket_purchasable_per_person} tickets max per person`}
                            typographyProps={{
                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                fontSize: {
                                    xs: 10,
                                    sm: 12,
                                    lg: 16,
                                },
                            }}
                        />
                    )}
                </Stack>
            </Stack>
        </React.Fragment>
    );
};

export { EventHighlight };
